export class ValidatorContents {
    public static InvalidPhone = "Invalid Phone Number";
    public static InvalidEmail = "Invalid email address";
    public static AlphaNumericOnly = "Please enter alphanumeric characters";
    public static AlphaNumericWithSpace = "Please enter alphanumeric characters with or without space";
    public static AlphanumericWithApostrophe = "Please enter alphanumeric characters with or without apostrophe";
    public static AlphaNumericWithSpecialCharacters =
        "Please enter alphanumeric characters with some special characters specified in brackets (!@#$&()\\`.+,/-)";
    public static Name50 = "Please enter characters only in the alphabet with or without a space, ' or -";
    public static Numeric2 = "Value must be 2 digits";
    public static Alphabetical1 = "Value must be an alphabet";
    public static MaxBankAccountsNumber = 10;
    public static MaxBackOfficeProvidersNumber = 3;
    public static NonZeroAccountNumber = "8 digit Account number cannot be all zeroes";
    public static NonZeroSortCode = "6 digit Sort code cannot be all zeroes";
    public static BankAccountNumberMustBeEightDigits = "Account number must have 8 digits";
    public static InvalidUKMobilePhone = "Invalid phone number, please enter an 11-digit number starting with 0";
    public static InvalidUKLandLinePhone = "Invalid phone number, please enter a number starting with 0";
}
